import Paper from '@mui/material/Paper';

import {  styled } from '@mui/material/styles';

export const Container = styled(Paper)(({ theme }) => ({
  minWidth: 150,
  padding: 16,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  rowGap: 4,

  '.icon-container': {
    width: 100,
    height: 100,
    marginBottom: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100px',

    '> svg': {
      width: 80,
      height: 80,
      color: theme.palette.primary.main,
    }
  },

  '> p': {
    fontSize: '0.875rem',
    fontWeight: 300,
    margin: 0,
  },

  '> strong': {
    fontSize: '1.25rem',
  },
}));
